module.exports = __webpack_public_path__ + "static/media/world.a3ba413f.svg";